import React from 'react';

function InputError({ errorMessage }) {
  return <div className="text-danger">{errorMessage}</div>;
}

class Input extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasChanged: false,
      isValid: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.setValue = this.setValue.bind(this);
    this.getValue = this.getValue.bind(this);
    this.reset = this.reset.bind(this);
    this.isValid = this.isValid.bind(this);
    this.setIsValid = this.setIsValid.bind(this);
  }

  setIsValid(bool) {
    this.setState({
      hasChanged: true,
      isValid: bool,
    });
  }

  setValue(value) {
    this.input.value = value;
  }

  getValue() {
    return this.input.value; // For React 0.14+
  }

  isValid() {
    return this.state.isValid;
  }

  reset() {
    this.setValue('');
    this.setState({
      hasChanged: false,
      isValid: false,
    });
  }

  handleChange(event) {
    if (this.props.validate) {
      this.setState({
        isValid: this.props.validate(event.target.value, event.target),
      });
    }

    this.setState({
      hasChanged: true,
    });
  }

  render() {
    // Show error block if the input value is not valid and input value has changed.
    const inputErrorBlock = (this.state.hasChanged && !this.state.isValid) ?
      (<InputError errorMessage={this.props.errorMessage} />) : null;

    return (
      <div>
        <input
          ref={(ref) => { this.input = ref; }}
          id={this.props.id}
          type={this.props.type || 'text'}
          name={this.props.name}
          className={this.props.className || 'form-control'}
          value={this.props.value === null ? undefined : this.props.value}
          placeholder={this.props.placeholder}
          style={this.props.style}
          onChange={this.handleChange}
          required={this.props.required}
        />
        {inputErrorBlock}
      </div>
    );
  }
}

export default Input;



// WEBPACK FOOTER //
// ./src/components/shared/Input.js